/**
 * Jackpot winner overlay for Dog Racing (DOM, Bingo-49 / Lucky Balls parity).
 * Source of truth: CheckIfDog6JackpotAwarded at RaceStatus = 1.
 */
const JackpotWinnerNotice = {
  winners: [],
  displayWinners: [],
  hideTimer: null,
  _winnerSignature: null,
  _shownSignature: null,
  _jackpotAwardedRoundId: null,

  config: {
    displayMs: 20000,
    maxBanners: 2,
    enableRegionalBanner: true,
    fetchTimeoutMs: 2500
  },

  getLabel(key, fallback) {
    var langCode = 'en';
    try {
      if (typeof language !== 'undefined' && language) {
        langCode = language;
      } else if (typeof window !== 'undefined' && window['language']) {
        langCode = window['language'];
      } else if (typeof window !== 'undefined' && window['lang']) {
        langCode = window['lang'];
      }
    } catch (e) {}

    if (typeof langArr !== 'undefined' && langArr[langCode] && langArr[langCode][key]) {
      return langArr[langCode][key];
    }
    return fallback;
  },

  _trim(value) {
    if (value == null) {
      return '';
    }
    return String(value).trim();
  },

  _firstDefined(obj, keys) {
    if (!obj) {
      return '';
    }
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (obj[key] != null && String(obj[key]).trim() !== '') {
        return this._trim(obj[key]);
      }
    }
    return '';
  },

  _normalizeWinnerObject(raw, kind) {
    if (!raw) {
      return null;
    }
    var entry = Array.isArray(raw) ? raw[0] : raw;
    if (!entry || typeof entry !== 'object') {
      return null;
    }

    var playerId = this._firstDefined(entry, [
      'PlayerID', 'PlayerId', 'ID_Player', 'playerId', 'Player'
    ]);
    var ticketId = this._firstDefined(entry, [
      'TicketID', 'TicketId', 'ticketId', 'Ticket'
    ]);

    if (!playerId && !ticketId) {
      return null;
    }

    return {
      kind: kind || 'global',
      playerId: playerId,
      ticketId: ticketId,
      signature: (kind || 'global') + '|' + ticketId + '|' + playerId
    };
  },

  parseAwardedResponse(response) {
    var winners = [];
    if (!response) {
      return winners;
    }

    var list = response.Jackpots;
    if ((!list || !list.length) && response.Data) {
      list = response.Data.Jackpots || response.Data;
    }
    if (!list) {
      return winners;
    }
    if (!Array.isArray(list)) {
      list = [list];
    }

    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (!item) {
        continue;
      }
      var level = parseInt(item.JackPotLevel != null ? item.JackPotLevel : item.JackpotLevel, 10);
      var kind = (level === 2 || level === 3) ? 'regional' : 'global';
      if (kind === 'regional' && !this.config.enableRegionalBanner) {
        continue;
      }
      var winner = this._normalizeWinnerObject(item, kind);
      if (winner) {
        winners.push(winner);
      }
    }

    winners.sort(function(a, b) {
      if (a.kind === b.kind) {
        return 0;
      }
      return a.kind === 'global' ? -1 : 1;
    });

    if (winners.length > this.config.maxBanners) {
      winners = winners.slice(0, this.config.maxBanners);
    }
    return winners;
  },

  _signatureForWinners(winners) {
    var parts = [];
    for (var i = 0; i < winners.length; i++) {
      parts.push(winners[i].signature);
    }
    return parts.join('::');
  },

  applyAwardedWinners(winners) {
    var built = Array.isArray(winners) ? winners.slice() : [];
    if (built.length > this.config.maxBanners) {
      built = built.slice(0, this.config.maxBanners);
    }

    var winSig = this._signatureForWinners(built);
    if (!built.length) {
      this._winnerSignature = null;
      this._shownSignature = null;
      this.winners = [];
      this.displayWinners = [];
      this.hide();
      return;
    }

    this._winnerSignature = winSig;
    this._shownSignature = null;
    this.winners = built;
    this.displayWinners = [];
  },

  fetchForDraw(roundKey, done, timeoutMs) {
    var self = this;
    var finished = false;
    var finish = function() {
      if (finished) {
        return;
      }
      finished = true;
      if (typeof done === 'function') {
        done();
      }
    };

    var roundId = String(roundKey || '');
    if (roundId && String(this._jackpotAwardedRoundId) === roundId) {
      finish();
      return;
    }
    if (roundId) {
      this._jackpotAwardedRoundId = roundId;
    }

    var timer = setTimeout(function() {
      console.warn('[dog-race] CheckIfDog6JackpotAwarded timed out');
      finish();
    }, timeoutMs || this.config.fetchTimeoutMs);

    try {
      $.ajax({
        url: window['API_URL'] + '/dog-race/game/jackpot-awarded',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ CheckIfDog6JackpotAwarded: 0 }),
        success: function(response) {
          clearTimeout(timer);
          try {
            console.info('[dog-race] CheckIfDog6JackpotAwarded response', response);
            var winners = self.parseAwardedResponse(response);
            self.applyAwardedWinners(winners);
          } catch (e) {
            console.warn('[dog-race] CheckIfDog6JackpotAwarded parse error', e);
          }
          finish();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          clearTimeout(timer);
          console.warn('[dog-race] CheckIfDog6JackpotAwarded failed', textStatus, errorThrown);
          finish();
        }
      });
    } catch (e) {
      clearTimeout(timer);
      console.warn('[dog-race] CheckIfDog6JackpotAwarded failed', e);
      finish();
    }
  },

  beginRaceJackpotFlow(raceData, done) {
    var roundKey = raceData && (raceData.ID_Today != null ? raceData.ID_Today : raceData.ID);
    this.fetchForDraw(roundKey, () => {
      this.onRaceStart();
      if (typeof done === 'function') {
        done();
      }
    });
  },

  onRaceStart() {
    if (!this.winners.length || !this._winnerSignature) {
      return;
    }
    if (this._shownSignature === this._winnerSignature) {
      return;
    }

    this._shownSignature = this._winnerSignature;
    this.displayWinners = this.winners.slice();
    this.showFor(this.config.displayMs);
  },

  ensureOverlay() {
    var host = document.getElementById('video-main');
    if (!host) {
      return null;
    }

    var overlay = document.getElementById('dr-jackpot-winner-notice');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'dr-jackpot-winner-notice';
      overlay.className = 'dr-jackpot-winner-notice';
      host.appendChild(overlay);
    }
    return overlay;
  },

  _getTitleForWinner(winner) {
    if (winner.kind === 'regional') {
      return this.getLabel(
        'jp_winner_title_regional',
        'CONGRATULATIONS TO THE REGIONAL JACKPOT WINNER!'
      );
    }
    return this.getLabel('jp_winner_title', 'CONGRATULATIONS TO THE JACKPOT WINNER!');
  },

  _formatPlayerLine(winner) {
    if (!winner || !winner.playerId) {
      return '';
    }
    var prefix = this.getLabel('jp_winner_player', 'Player');
    return prefix + ': ' + winner.playerId;
  },

  renderPanels() {
    var overlay = this.ensureOverlay();
    if (!overlay) {
      return;
    }

    overlay.innerHTML = '';
    for (var i = 0; i < this.displayWinners.length; i++) {
      var winner = this.displayWinners[i];
      var panel = document.createElement('div');
      panel.className = 'dr-jp-winner-panel';

      var title = document.createElement('div');
      title.className = 'dr-jp-winner-title';
      title.textContent = this._getTitleForWinner(winner);
      panel.appendChild(title);

      var playerLine = this._formatPlayerLine(winner);
      if (playerLine) {
        var playerEl = document.createElement('div');
        playerEl.className = 'dr-jp-winner-line';
        playerEl.textContent = playerLine;
        panel.appendChild(playerEl);
      }

      if (winner.ticketId) {
        var ticketEl = document.createElement('div');
        ticketEl.className = 'dr-jp-winner-line dr-jp-winner-ticket';
        ticketEl.textContent = winner.ticketId;
        panel.appendChild(ticketEl);
      }

      overlay.appendChild(panel);
    }
  },

  showFor(ms) {
    if (!this.displayWinners.length) {
      return;
    }

    var overlay = this.ensureOverlay();
    if (!overlay) {
      return;
    }

    this.renderPanels();
    overlay.style.display = 'flex';

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    var self = this;
    this.hideTimer = setTimeout(function() {
      self.hide();
    }, ms || this.config.displayMs);
  },

  hide() {
    var overlay = document.getElementById('dr-jackpot-winner-notice');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.innerHTML = '';
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
};

export default JackpotWinnerNotice;



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/helpers/jackpot-winner-notice.js
// module id = 1948
// module chunks = 7